// @flow

export const TEXT_TYPE = 'text'
export const BLOCKQUOTE_TYPE = 'blockquote'
